import { endOfDay } from "date-fns/endOfDay";
import { parseISO } from "date-fns/parseISO";
import { startOfDay } from "date-fns/startOfDay";
import type { Tool } from "~generated";
import { config } from "~initializer/config.ts";
import { isInventoryPeriod } from "./inventoryPeriod.ts";

export { isInventoryPeriod } from "./inventoryPeriod.ts";

export const FIRST_INVENTORY_YEAR = config().inventoryFirstYear;

export function getCurrentInventoryYear() {
  const { inventoryStartMonth, inventoryStartDay } = config();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const inventoryPeriodStart = startOfDay(
    new Date(currentYear, inventoryStartMonth - 1, inventoryStartDay),
  );

  if (currentDate < inventoryPeriodStart) {
    return currentYear - 1;
  }

  return currentYear;
}

// Human-readable label for an inventory period. The period spans two calendar
// years (01.10.year - 30.09.year+1), so it is displayed as "2025/2026".
export function formatInventoryPeriod(year: number) {
  return `${year}/${year + 1}`;
}

// End of the inventory period for a given inventory year. The period spans into
// the following calendar year (e.g. 01.10.2025 - 30.09.2026).
function getInventoryPeriodEnd(year: number) {
  const { inventoryEndMonth, inventoryEndDay } = config();
  return endOfDay(new Date(year + 1, inventoryEndMonth - 1, inventoryEndDay));
}

export function canInventoryTool(tool: Tool) {
  return (
    isInventoryPeriod() &&
    !tool.inventory &&
    isToolEligibleForCurrentInventory(tool)
  );
}

// A tool can be inventoried in the current period if it was acquired anytime up
// to the end of that period, including devices acquired within the running period.
export function isToolEligibleForCurrentInventory(tool: Tool) {
  return (
    parseISO(tool.created_at) <=
    getInventoryPeriodEnd(getCurrentInventoryYear())
  );
}
